module.exports = __webpack_public_path__ + "img/ommax-mba-header.7e81f673.jpg";